<template>
  <div class="salary-rules__rule-container">
    <div class="d-input-group--toggler"
         :class="{'d-input-group--toggler--active': isOn}"
         @click="setIsOn">
      <label class="d-label">
        Skal vikaren have et minimum antal timer om dagen
      </label>
      <AppToggle :allowChanges="false" :propOn="isOn"></AppToggle>
    </div>
    <div class="d-group" v-if="isOn">
      <label class="d-label">Hvor mange minutter skal vikaren minimum have?</label>
      <input type="number" ref="input_number" v-model="minutes" class="d-input">
    </div>
    <SalaryRulesRule
      v-if="isOn"
      :subjectType="subjectType"
      :propSelectedEmploymentTypeId="selectedEmploymentTypeId"
      @change="setRuleEmployment"
    >
    </SalaryRulesRule>
    <div class="d-modal__buttons" v-if="isChangesMade">
      <button class="do-bttn do-bttn--submit" @click="onSubmit">{{ $t('vue2.common.save') }}</button>
    </div>
  </div>
</template>
<script>
import AppToggle from '../../common/AppToggle.vue'
import TimeInput from '../../timechanger/TimeInput.vue'
import SalaryRulesRule from './SalaryRulesRule.vue'

export default {
  components: {SalaryRulesRule, TimeInput, AppToggle},
  props: {
    config: {
      type: Object,
      default: null
    },
    propRules: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      isOn: false,
      minutes: 120,
      subjectType: '_extra_time_if_shorter_than_',
      selectedEmploymentTypeId: ''
    }
  },
  computed: {
    initMinutes () {
      return this.config && this.config.if_shorter_than && this.config.if_shorter_than.minutes
    },
    initSelectedEmploymentTypeId () {
      if (!this.propRules) {
        return ''
      }
      const idx = this.propRules.findIndex(item => item.id === this.subjectType)
      if (idx < 0) {
        return ''
      }
      return this.propRules[idx]['selected_employment_title']
    },
    isChangesMade () {
      if (this.isOn) {
        return (this.initMinutes !== (this.minutes * 1)) || this.initSelectedEmploymentTypeId !== this.selectedEmploymentTypeId
      } else {
        return this.config && this.config.if_shorter_than
      }
    }
  },
  methods: {
    setRuleEmployment (selectedEmploymentTypeId) {
      this.selectedEmploymentTypeId = selectedEmploymentTypeId
    },
    newRulesArr () {
      if (!this.isOn || this.selectedEmploymentTypeId === '') {
        return this.propRules.filter(item => item.id !== this.subjectType)
      }
      const dbRules = JSON.parse(JSON.stringify(this.propRules))
      const idx = dbRules.findIndex(item => item.id === this.subjectType)
      if (idx < 0) {
        const newRuleObj = {
          id: this.subjectType,
          type: 'subject_type',
          subject_type: this.subjectType,
          selected_employment_title: this.selectedEmploymentTypeId
        }
        dbRules.unshift(newRuleObj) // Brug unshift() for at tilføje i starten af arrayet
      } else {
        dbRules[idx].selected_employment_title = this.selectedEmploymentTypeId
      }
      return dbRules
    },
    setIsOn () {
      this.isOn = !this.isOn
      if (this.isOn) {
        this.$nextTick(_ => {
          this.$refs.input_number.focus()
        })
      }
    },
    onSubmit () {
      let dbConfig = JSON.parse(JSON.stringify(this.config))
      if (!this.isOn) {
        delete dbConfig.if_shorter_than
      } else {
        dbConfig.if_shorter_than = {minutes: this.minutes * 1}
      }
      this.$emit('onSubmit', dbConfig, this.newRulesArr())
    }
  },
  mounted () {
    if (this.propRules) {
      const idx = this.propRules.findIndex(item => item.id === this.subjectType)
      if (idx > -1) {
        const employmentId = JSON.parse(JSON.stringify(this.propRules[idx]['selected_employment_title']))
        this.selectedEmploymentTypeId = employmentId
      }
    }
    if (this.config && this.config.if_shorter_than && this.config.if_shorter_than.minutes) {
      this.isOn = true
      this.minutes = JSON.parse(JSON.stringify(this.config.if_shorter_than.minutes * 1))
    }
  }
}
</script>

<style scoped>

.salary-rules__rule-container {
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  padding: 32px;
  padding: 2rem;
  border-radius: 4px;
  max-width: 600px;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-group .d-input {
  height: 34px;
  max-width: 150px;
  text-align: right;
}

.d-group {
  margin: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// SalaryRule3.vue?4fed79ba